import ApiClient from './ApiClient';

class TicketNotes extends ApiClient {
  constructor() {
    super('notes', { accountScoped: true });
    this.ticketId = null;
  }

  get url() {
    return `${this.baseUrl()}/tickets/${this.ticketId}/notes`;
  }

  get(ticketId) {
    this.ticketId = ticketId;
    return super.get();
  }

  create(ticketId, content, file) {
    this.ticketId = ticketId;

    if (file) {
      const formData = new FormData();
      formData.append('note[content]', content);
      formData.append('note[ticket_id]', ticketId);
      formData.append('note[file]', file);

      return axios.post(this.url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }

    return super.create({ content, ticket_id: ticketId });
  }

  delete(ticketId, id) {
    this.ticketId = ticketId;
    return super.delete(id);
  }
}

export default new TicketNotes();
